/**
 * 表がスクロールできることをおしらせ
 */
import ResizeWatch from '../utils/ResizeWatch';
import ScrollWatch from '../utils/ScrollWatch';
import AnyStore from '../common/AnyStore';

export default class ScrollOverlaySol {
  /**
   * コンストラクタ
   */
  constructor(parent) {
    this.name = 'ScrollOverlaySol'; // クラス名
    this.isFin = false;

    if (document.querySelector('.p-scroll-overlay--sol')) {
      this.init();
    }
  }

  /**
   * 初期化
   */
  init() {
    // イベント設定
    this.resizeUpdate();
    ResizeWatch.registerObserver(this.name, this);
    ScrollWatch.registerObserver(this.name, this);
  }

  /**
   * リサイズ
   */
  resizeUpdate() {
    // スクロール再処理
    this.scrollUpdate(ScrollWatch._currentScrollY());
  }

  /**
   * スクロール
   */
  scrollUpdate(_scrollY) {
    const tY = _scrollY + (window.innerHeight * 0.5);
    if (tY > AnyStore.getOffsetTop(document.querySelector('.p-scroll-overlay--sol')).top) {
      this.isFin = true;
      ResizeWatch.cancelObserver(this.name);
      ScrollWatch.cancelObserver(this.name);

      // scroll表示消す
      TweenMax.set(document.querySelector('.p-scroll-overlay--sol'), {className: '-=is-overlay'});
      TweenMax.to(document.querySelector('.p-scroll-sign'), 0.6, {x: 50, opacity: 0, display: 'none'});
    }
  }
}